// extracted by mini-css-extract-plugin
module.exports = {"button":"BackButton_button__3jd30","icon":"BackButton_icon__2YLkL","container":"BackButton_container__UPJB2"};